import 'babel-polyfill';
import '@/assets/css/main.css';
import Vue from 'vue';
import './plugins/vuetify';
import ValidationRules from '@/validation';
import VueRouter from 'vue-router';
import routes from './routes';
import LayoutView from './views/layout.vue';
import MoedaFilter from './filters/moeda';
import Store from './store';
import initializer from './initializer';

Vue.use(VueRouter);

Vue.prototype.$store = Store;
Vue.prototype.$rules = ValidationRules;

let router = new VueRouter({ routes, linkActiveClass: 'active' });

Vue.config.productionTip = false;

Vue.filter('moeda', MoedaFilter);

initializer(router);

new Vue({
	router,
	render: h => h(LayoutView)
}).$mount('#app');